var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"grouped-list__title"},[_c('span',{staticClass:"grouped-list__title-text"},[_vm._t("title")],2),_c('ul',{staticClass:"grouped-list-nested grouped-list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }